import { IStairConfig } from '@stair-craft/common/util';

import { IPlanPoint } from '../shared-plan-geometry/plan-geometry';
import { DEFAULT_DIAMETER } from '../spiral-calculate-layout/calculate-layout';

/** The opening rectangle in room millimetres: the config and the calculated room both carry it. */
export interface IOpeningRect {
    readonly openingX: number;
    readonly openingZ: number;
    readonly openingWidth: number;
    readonly openingLength: number;
}

/** The config fields the placement reads. */
export type IPlacementConfig = Pick<IStairConfig, 'type' | 'turnDirection' | 'stairWidth' | 'spiralDiameter'>;

/**
 * Where the stair's own (0, 0) sits in room millimetres: stair coordinates plus this give the
 * room's. A straight, L or U stair ends at the far edge of the opening along Z, a left turn
 * hugs the opening's right side; a spiral stands in the middle of its opening. The viewport,
 * the plan, the joint check and the calculators all place the stair by this one function.
 */
export function stairPlacement(config: IPlacementConfig, opening: IOpeningRect, totalRun: number): IPlanPoint {
    if (config.type === 'spiral') {
        const diameter: number = config.spiralDiameter ?? DEFAULT_DIAMETER;
        return {
            x: opening.openingX + (opening.openingWidth - diameter) / 2,
            z: opening.openingZ + (opening.openingLength - diameter) / 2,
        };
    }
    const turnsLeft: boolean = (config.type === 'l-shape' || config.type === 'u-shape') && config.turnDirection === 'left';
    return {
        x: turnsLeft ? opening.openingX + opening.openingWidth - config.stairWidth : opening.openingX,
        z: opening.openingZ + opening.openingLength - totalRun,
    };
}
